/// <summary>
///
/// </summary>
/// <param name="" type="">***</param>
/// <param name="" type="">***</param>
import Clipboard from 'clipboard'


export default function handleClipboard(event, text){
  const clipboard =  new Clipboard(event.target,{
    text:()=>text
  })
  clipboard.on('success',() => {
    clipboard.destroy()
  })
  clipboard.on('error',() =>{
    clipboard.destroy()
  })
  clipboard.onClick(event)
}
